import { PublicFeedback } from "./PublicFeedback";
import { PartialPost, PostId } from "./RootPost";

export class CountsByType {
    public idea: number = 0;
    public problem: number = 0;
}

export class SearchResults {
    public results: SearchResult[] = [];
    public isPrivateBuild: boolean;
    public isDecliningFeedback: boolean;
    public tagList: string[] = [];
    public totalCount: number; // only sent if the request has "returnTotalCount == true"
    public countsByType: CountsByType | null; // only sent if the request has "includeCountsByType = true"
}

export class SearchResult extends PublicFeedback implements PartialPost {
    public id: PostId; // computed property

    public searchScore: number; // unused; keep for backward compatibility with VS for Mac C# code

    /**
     * for non-AI search: score value rank e.g 5.0, 6.34, etc.
     * for AI search: Value between 0.33 and 1 indicating how well this result matched the search query.
     *     See https://learn.microsoft.com/en-us/azure/search/vector-search-ranking
     */
    public searchScoreF: number;

    public totalVotes: number;
    public hasVoted: boolean;
    public iCreatedThis: boolean;
    public isFollowing: boolean | null = null;

    public answerHubId: number;
    public spaceId: number;

    public createdBy: string; // author name
    public createdByUrl: string; // author user profile url
    public createdDateUtc: Date;
    public createdByVsoId: string;
    public createdByImageLink: string;
    public lastModifiedBy: string;
    public lastModifiedByUrl: string;
    public lastModifiedUtc: Date;

    // current on AH website: 2016-09-22 NikolaMi: triaged, duplicate, fixed, notabug, wont-fix, pending, more-info, new, investigation
    public state: string;

    public commentCount: number; // comment count for problem
    public solutionCount: number; // comment count for problem

    public communityUrl: string;

    public cantVote: boolean;
    public cantComment: boolean;
    public cantAnswer: boolean;

    public intUrl: string | null; // internal ADO ticket URL, if any and permitted
}
